//generate landing page
/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Landing page for the application
Author: GMV

Version: 1.0
*/
import React, { Suspense } from 'react';
import { Container } from "reactstrap";
import TopBarLogin from '../../core/components/topbarLogin/TopBar';
import { useCookies } from 'react-cookie';

export default function Policy() {

    const [cookie] = useCookies(['TosAccepted']);

    return (
        <div className="content-page" style={{ overflow: cookie.TosAccepted ? 'scroll' : undefined, paddingTop: cookie.TosAccepted ? undefined : '0' }}>
           {cookie.TosAccepted ?
                <Suspense>
                    <TopBarLogin />
                </Suspense>
            : null
            }
            <div className="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
                <Container className="align-center ">
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <div style={{ width: '80%' }}>
                            <h1 style={{ color: '#003247' }}
                            >Privacy Policy for the Colletion and Processing of Personal Data Pursuant to Articles 13 of Regulation (EU) 679/2016 of 27 April 2016</h1>
                            
                            <p
                            >This privacy policy is issued pursuant to Art. 13 of Regulation (EU) 2016/679 of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and compliance with the legislation on the processing of personal data, as well as the free movement of such data.
                            </p>

                            <p
                            >In particular, this privacy policy applies to the user’s information (i.e. user’s name and email) for the European Space Agency software THEMIS.
                            </p>

                            <h3  style={{ color: '#003247' }} 
                            >Data Controller
                            </h3>
                            
                            <p
                            >Politecnico di Milano - Director General delegated by the pro-tempore Rector - contact: <a href="mailto:dirgen@polimi.it">dirgen@polimi.it</a>.
                            </p>

                            <h3  style={{ color: '#003247' }} 
                            >Internal data processor
                            </h3>

                            <p
                            >The internal data processor is Ing. Andrea Milanese - e.mail: <a href="mailto:andrea.milanese@polimi.it">andrea.milanese@polimi.it</a>.
                            The data shall be processed by other persons authorised and instructed for this purpose in accordance with current legislation. 
                            </p>

                            <h3  style={{ color: '#003247' }} 
                            >Data Protection Officer and contact details
                            </h3>

                            <p
                            >E-mail: <a href="mailto:privacy@polimi.it">privacy@polimi.it</a> - Tel. 02 23999378.
                            </p>

                            
                            <h3  style={{ color: '#003247' }} 
                            >Purpose of the processing, legal basis, categories of data and retention period.
                            </h3>

                            <p
                            >For the purposes of applying the relevant European and national legislation (Regulation EU 679/2016, henceforth “Regulation”), we hereby inform you that your personal data will be used for the following purposes:
                            </p>
                            
                            <h4  style={{ color: '#003247' }} 
                            >Intended purpose of the personal data processing
                            </h4>

                            <ul>
                                <li><b>Purpose 1</b> - Identify user’s contact for login into the app</li>
                            </ul>

                            <h4  style={{ color: '#003247' }} 
                            >Legal basis of the processing
                            </h4>

                            <p>
                            Consensum (art. 6, par. 2, lett. a) Regulation UE).
                            </p>

                            <h4  style={{ color: '#003247' }} 
                            >Categories of personal data subject to processing
                            </h4>

                            <ul>
                                <li>Personal details</li>
                                <li>Contact details</li>
                            </ul>

                            
                            <h4 
                            >Retention period of personal data
                            </h4>

                            <p
                            >The data collected shall be stored for a period needed for storing the customer’s defined mission saved by the users.                            
                            </p>

                            <h3  style={{ color: '#003247' }} 
                            >Nature of the data
                            </h3>

                            <p
                            >The provision of the data requested for Purpose 1 is mandatory. In the event of failure to provide the data requested, the planned services/activities cannot be guaranteed. 
                            </p>

                            <h3  style={{ color: '#003247' }} 
                            >Rights of data subjects
                            </h3>

                            <p
                            >As a data subject, you can ask the Data Controller for the following at any time: 
                            </p>

                            <ul>
                                <li>confirmation of any personal data held concerning you; </li>
                                <li>access to your personal data and related information; the correction of inaccurate data or the completion of incomplete data; the cancellation of personal data concerning you (where any of the conditions indicated in Art. 17, paragraph 1 of the Regulation applies and in compliance with the exceptions provided for in paragraph 3 of the same article); the restriction of the processing of your personal data (where one of the conditions indicated in Art. 18, paragraph 1 of the Regulation applies), the transformation into anonymous form or the blocking of data processed in violation of the law, including those that do not need to be kept for the purposes for which the data were collected or subsequently processed;</li>
                            </ul>

                            <p
                            >As a data subject, you also have the right to object in whole or in part:
                            </p>

                            <ul>
                                <li>for legitimate reasons, to the processing of personal data concerning you, even if pertinent to the purpose of the collection; </li>
                                <li>to the processing of personal data concerning you for the purpose of sending advertisements on courses and cultural events at the Politecnico di Milano.</li>
                            </ul>

                            <p
                            >These rights can be exercised by contacting <a href="mailto:privacy@polimi.it">privacy@polimi.it</a>.
                            </p>

                            <p
                            >If you believe that your rights have been violated by the data controller and/or a third party, you have the right to lodge a complaint with the Personal Data Protection Authority and/or other competent supervisory authority pursuant to the Regulation.
                            </p>

                            <p 
                            >Milan, 11/04/2025
                            </p>

                        </div>
                    </div>
                </Container>
            </div>
        </div>
    );
}
